import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../../PanelPage";
import {Messages} from "../../../../../Messages";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {Router} from "../../../../../../stem-core/src/ui/Router";
import {MessageElement} from "../../../../../widget/ui/MessageElement";
import {SubscriptionFlowHandler} from "../../../../flows/SubscriptionFlowHandler.js";


export class EditSubscriptionCancelPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.editSubscriptionCancelTitle,
        };
    }

    render() {
        const subscription = SubscriptionFlowHandler.getSubscriptionToCancel();
        const {styleSheet} = this;

        return [
            <MessageElement
                className={styleSheet.description}
                message={Messages.editSubscriptionCancelText1(
                    subscription.coverage.name, subscription.formatPrice(),
                    subscription.getActiveUntil().format("MMMM DD, YYYY")
                )}
            />,
            <div className={styleSheet.description}>
                {Messages.editSubscriptionCancelText2}
            </div>,
            <MerchantButton onClick={() => SubscriptionFlowHandler.cancel(subscription)} className={styleSheet.actionButton}>
                {Messages.editSubscriptionCancelButton}
            </MerchantButton>,
            <div onClick={() => Router.back()} className={styleSheet.backButton}>
                {Messages.back}
            </div>
        ]
    }
}
